<template>
  <div class="bottom">
    <div class="left">
      <span class="ydl">阅读量 {{ ydl || '' }}</span>
      <!-- <div  class="flex-center">
                <img v-if="object.isDz" src="@images/xxgk/dz1.png" class="dz-img" @click="clickQxdz(item)" />
                <img v-else src="@images/xxgk/dz.png" class="dz-img" @click="clickQxdz(item)" />
                <span class="dz-text">1</span>
          </div> -->
    </div>
    <!-- <div v-show="false" class="right" @click="clickShare">分享
        <van-icon name="share" color="#3875f6"/>
        {{object.fxl}}
      </div> -->
    <div class="flex-center">
      <img v-if="object.dzzkId" src="@images/xxgk/dz1.png" class="dz-img" @click="clickQxdz()"/>
      <img v-else src="@images/xxgk/dz.png" class="dz-img"   @click="clickDz()"  />
      <span class="dz-text">{{ dzsNum }}</span>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { getAction, postAction } from '@/api/manage'
export default {
  name: 'bottomShare',
  props: {
    ydl: {
      type: [String, Number],
      default: '',
    },
    dzs: {
      type: [String, Number],
      default: '',
    },
    isDz: {
      type: String,
      default: '',
    },
    obj: {
      type: Object,
      default() {
        return {}
      },
    },
    dzlx: {
      type: String,
      default: '03',
    },
    glLx: {
      type: String,
      default: '05',
    },
  },
  data() {
    return {
      object: {},
      dzsNum:0,
    }
  },
  watch: {
			  obj: {
			  	immediate: true,
			  	handler() {
			  		this.object = this.obj;
			  	},
			  },
			  dzs: {
			  	immediate: true,
			  	handler() {
			  		this.dzsNum = this.dzs;
			  	},
			  },
			},
  created() {
    
  },
  methods: {
    clickDz() {
      let openId = this.$store.getters.openId
      let params = { glId: this.object.id, openid: openId, dzlx: this.dzlx, glLx: this.glLx }
      getAction('/zhshj/dzzk/dzzk', params).then((res) => {
        if (res.success) {
            this.dzsNum = Number(this.dzsNum)+1;
            let obj = res.result;
             this.object.dzzkId = obj.id;
        }
      })
    },
    clickQxdz() {

      let openId = this.$store.getters.openId
      let params = { dzzkId: this.obj.dzzkId, openId: openId }
      getAction('/zhshj/dzzk/dzzkqx', params).then((res) => {
        if (res.success) {
          this.object.dzzkId = "";
          this.dzsNum = Number(this.dzsNum) - 1;
        }
      })
    },
    clickShare() {
      let shareMessage = { title: '分享标题', desc: '分享描述', link: '' }
      this.initWxInfo()
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: shareMessage.title, // 分享标题
          desc: shareMessage.desc, // 分享描述
          link: shareMessage.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: '', // 分享图标
          success: function () {
            // 设置成功
            this.$toast('注册成功')
          },
        })
      })
      this.$toast('点击右上角三个点分享')
    },
    initWxInfo() {
      let urlHref = encodeURIComponent(window.location.href)
      let params = { url: urlHref }
      let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
      postAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名，见附录1
            jsApiList: [
              'updateTimelineShareData',
              'updateAppMessageShareData',
              'onMenuShareAppMessage',
              'onMenuShareTimeline',
            ],
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  font-size: 15px;
  box-sizing: border-box;

  .left {
    display: flex;
    align-items: center;
  }

  .flex-center {
    display: flex;
    align-items: center;

    .dz-img {
      width: 20px;
      height: 20px;
    }
    .dz-text {
      color: #3875f6;
      margin-left: 6px;
    }
  }

  .ydl {
    margin-right: 12px;
  }
}
</style>
